import { render, staticRenderFns } from "./base-textarea.vue?vue&type=template&id=69954912&scoped=true"
import script from "./base-textarea.vue?vue&type=script&lang=js"
export * from "./base-textarea.vue?vue&type=script&lang=js"
import style0 from "./base-textarea.vue?vue&type=style&index=0&id=69954912&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69954912",
  null
  
)

export default component.exports